import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import Modal from '../../../../../../common/molecules/Modal';
import RecommendationTileView from '../../../../../../common/molecules/RecommendationCarousel/views/RecommendationTile.view';
import { getCurrencyAttributes } from '../../../../../../../reduxStore/selectors/currency.selectors';
import {
  getCurrentCurrencySymbol,
  getIsDynamicBadgeEnabled,
  getIsHideOriginalPriceAndMarchantTagEnabled,
} from '../../../../../../../reduxStore/selectors/session.selectors';
import { openQuickViewWithValues } from '../../../../../../common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  getMonetateEnabledFlag,
  getProducts,
  getRecommendationLoadingState,
} from '../../../../../../common/molecules/Recommendations/container/Recommendations.selector';
import { modalStyles } from '../styles/QuickAddFreeShippingRecsModal.styles';
import {
  getCartItemsSelector,
  getCartProductIds,
  getQuickAddRecommendationType,
} from '../../../../BagPage/container/BagPage.selectors';
import {
  clearRecommendationData,
  fetchRecommendationsDataMonetate,
} from '../../../../../../common/molecules/Recommendations/container/Recommendations.actions';

const showQASkeleton = () => {
  return (
    <>
      <LoaderSkelton className="recommendation-tile" height="315px" />
      <LoaderSkelton className="recommendation-tile" height="315px" />
      <LoaderSkelton className="recommendation-tile" height="315px" />
      <LoaderSkelton className="recommendation-tile" height="315px" />
    </>
  );
};

const QuickAddFreeShippingRecsModal = (props) => {
  const {
    isQuickAddModalOpen,
    onRequestClose,
    products,
    currencyAttributes,
    currencySymbol,
    isDynamicBadgeEnabled,
    onQuickViewOpenClick,
    isHideOriginalPriceAndMarchantTagEnabled,
    excludedIds,
    isMonetateEnabled,
    cartItems,
    loadRecommendationsMonetate,
    clearRecommendationDataForCart,
    isLoading,
    recomType,
  } = props;

  useEffect(() => {
    const action = {
      page: 'quick-add',
      excludedIds,
      provider: 'Monetate',
      MONETATE_ENABLED: isMonetateEnabled,
      reduxKey: recomType,
      cartItems,
      birthdayDepartment: '',
      recCarouselType: recomType,
    };
    loadRecommendationsMonetate(action);
    return () => {
      if (recomType) {
        clearRecommendationDataForCart(recomType);
      }
    };
  }, []);

  return (
    <Modal
      isOpen={isQuickAddModalOpen}
      onRequestClose={onRequestClose}
      overlayClassName="TCPModal__Overlay"
      className="TCPModal__Content"
      heightConfig={{ height: '90%' }}
      closeIconDataLocator="detailmodalcrossicon"
      heading="Add On Items"
      fixedWidth
      inheritedStyles={modalStyles}
      innerContentClassName="free-shipping-recs-content"
    >
      <div className="quick-add-recs-wrapper">
        {isLoading
          ? showQASkeleton()
          : products?.map((product, index) => {
              const productId = product.generalProductId;
              return (
                <RecommendationTileView
                  key={productId}
                  product={product}
                  index={index}
                  isHideOriginalPriceAndMarchantTagEnabled={
                    isHideOriginalPriceAndMarchantTagEnabled
                  }
                  isDynamicBadgeEnabled={isDynamicBadgeEnabled}
                  headerLabel="Add On Items"
                  page="cart"
                  currencySymbol={currencySymbol}
                  currencyAttributes={currencyAttributes}
                  onQuickViewOpenClick={onQuickViewOpenClick}
                  fromPageBranch="add-on-items"
                  bagItemCount
                  isBagPage
                />
              );
            })}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const recomType = getQuickAddRecommendationType(state);
  return {
    currencyAttributes: getCurrencyAttributes(state),
    currencySymbol: getCurrentCurrencySymbol(state),
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isHideOriginalPriceAndMarchantTagEnabled: getIsHideOriginalPriceAndMarchantTagEnabled(state),
    products: getProducts(state, recomType),
    excludedIds: getCartProductIds(state),
    isMonetateEnabled: getMonetateEnabledFlag(),
    cartItems: getCartItemsSelector(state),
    isLoading: getRecommendationLoadingState(state),
    recomType,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
    loadRecommendationsMonetate: (action) => {
      dispatch(fetchRecommendationsDataMonetate(action));
    },
    clearRecommendationDataForCart: (payload) => {
      dispatch(clearRecommendationData(payload));
    },
  };
};

QuickAddFreeShippingRecsModal.propTypes = {
  products: PropTypes.shape([]),
  excludedIds: PropTypes.string,
  isMonetateEnabled: PropTypes.bool,
  cartItems: PropTypes.shape([]),
  loadRecommendationsMonetate: PropTypes.func,
  clearRecommendationDataForCart: PropTypes.func,
  isLoading: PropTypes.bool,
  isQuickAddModalOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  isHideOriginalPriceAndMarchantTagEnabled: PropTypes.bool.isRequired,
  onQuickViewOpenClick: PropTypes.func,
};
QuickAddFreeShippingRecsModal.defaultProps = {
  products: [],
  excludedIds: '',
  isMonetateEnabled: false,
  cartItems: [],
  loadRecommendationsMonetate: () => {},
  clearRecommendationDataForCart: () => {},
  isLoading: false,
  onRequestClose: () => {},
  onQuickViewOpenClick: () => {},
};

export default connect(mapStateToProps, mapDispatchToProps)(QuickAddFreeShippingRecsModal);
export { QuickAddFreeShippingRecsModal as QuickAddFreeShippingRecsModalVanilla };
